import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	column-gap: 6px;
	font-size: ${helpers.font.size.large};
	font-weight: 500;
`
